import { variant } from 'styled-system';
export const scale = variant({
  prop: 'scale',
  variants: {
    small: {
      minHeight: '32px'
    },
    medium: {
      minHeight: '48px'
    },
    large: {
      minHeight: '56px'
    }
  }
});